// extracted by mini-css-extract-plugin
export default {"tabSlider":"ZztD5D80gHY7lmpLCEajthWS1q7x+2x2IdSRVa+ZKVY="};